import styled from 'styled-components'
import { Box, Banner, getPaletteColor } from 'pcln-design-system'
export const FlexDatesWrapper = styled.li`
  ${Box};
  background-color: ${getPaletteColor('background.lightest')};
  list-style-type: none;

  ${(props) => props.theme.flyQueries.tablet} {
    margin: 20px 4px 20px 4px;
  }

  ${(props) => props.theme.flyQueries.desktop} {
    margin: 0 0 15px 0;
  }
`

export const FlexDatesContainer = styled(Box)`
  margin-bottom: 10px;
  border: 1px solid ${getPaletteColor('primary.base')};
`

export const DatesBanner = styled(Banner)`
  padding: 10px 20px;
  color: ${getPaletteColor('text.lightest')};
  font-weight: 600;
  font-size: 14px;

  ${(props) => props.theme.flyQueries.tablet} {
    font-size: 16px;
  }
`
